<template>
    <div class="oasispay-packagebox-componesnts">
        <div class="oasispay-packagebox-1" v-if="packagelistDone">
            <div class="oasispay-title">
                <div class="oasispay-title-l"><i v-html="packagelist.countrylength > 1 ? 3:2"></i><span v-html="$t('select_pay_type')">Please choose your payment method</span></div>
                <div class="oasispay-title-r"></div>
            </div>
            <div class="oasispay-package-index-cont">
                <!--pay type-->
                <div class="oasispay-package-type">
                    <div @click="CLICK_USER_SELECTED_TYPE({key:key,item:item})"
                         :class="`oasispay-package-type-item ${item['channel_type']} ${setPayTypeActiveCssName(key)}`"
                         v-for="item,key in GET_PAY_TYPE_DATA"
                         :data-key="key"
                    >
                        <div class="oasispay-package-type-main"><i></i><strong>{{$t('type_' + item['channel_type'])}}</strong><span></span></div>
                        <div class="oasispay-package-type-other" v-if="item['channel_type'] === 'creditcard'"><i class="visa"></i><i
                            class="masterCard"></i><i class="3pay"></i></div>
                    </div>
                </div>
                <!--pay type end-->
                <!--channel content-->
                <div class="oasispay-package-cont">
                    <!--loading-->
                    <div class="xloading" v-show="$packageLoadedDoen">
                        <div class="xloading-wrap"></div>
                        <div class="xloading-animate"></div>
                    </div>
                    <!--loading end-->
                    <div class="oasispay-package-list">
                        <!--method-->
                        <div class="oasispay-package-method-warp">
                            <div class="oasispay-package-method-title"><span class="active">{{$t('select_pay_channel')}}<i></i></span></div>
                            <div class="oasispay-package-method-cont">
                                <ul>
                                    <li @click="CLICK_USER_SELECTED_CHANNEL({key:key,item:item})" :class="setChannelActiveCssName(key,item)"
                                        :data-value="key + ':' + item['channel_code'] + ':' + item['channel_sub_code']"
                                        :data-channel="item['channel_type']"
                                        :title="item['channel_show_name'] + item['channel_sub_name']"
                                        v-for="item,key in GET_PAY_CHANNEL_DATA">
                                        <span v-if="!item['channel_logo']" v-html="item['channel_show_name']"></span>
                                        <img v-if="item['channel_logo']" :src="item['channel_logo']" :alt="item['channel_name']"><i class="hot" v-if="item['best']==='Y'"></i><i
                                        class="yes"></i></li>

                                </ul>
                            </div>
                        </div>
                        <!--method end-->
                        <!--packages-->
                        <div class="oasispay-package-cont-warp">
                            <Packages></Packages>
                        </div>
                        <!--packages-->
                    </div>
                </div>
                <!--channel content end-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
    import Packages from '../package/Index';


    export default {
        name: 'packageBox',
        components: {
            Packages
        },
        data() {
            return {
            };
        },
        computed: {
            ...mapState(['$modulList','$packageLoadedDoen']),
            ...mapState('Module_Package', ['packagelist', 'packagelistDone']),
            ...mapGetters('Module_Package',['GET_PAY_TYPE_DATA','GET_PAY_CHANNEL_DATA'])
        },

        created() {},

        methods: {
            /**
             * 获取支付渠道当前状态
             * @param key
             * @returns {string}
             */
            setChannelActiveCssName(key,item){
                return key === this.packagelist.channelSelectedStatus[item.type_md5_key] ? 'active' : '';
            },

            /**
             * 获取支付类型当前状态
             * @param key
             * @returns {string}
             */
            setPayTypeActiveCssName(key){
                return key === this.packagelist.payTypeSelectedStatus[this.packagelist.countrySelectedStatus] ? 'active' : '';
            },

            ...mapActions('Module_Package', ['GET_PACKAGE_LIST_INFO', 'GET_USER_LAST_PAY_INFO', 'CLICK_USER_SELECTED_TYPE','CLICK_USER_SELECTED_CHANNEL']),
        }
    };
</script>
<style type="scss">


    .oasispay-package-method-cont ul, .oasispay-package-type-main {
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
    }

    .oasispay-package-method-cont li {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .oasispay-package-method-cont li img {
        width: 100%;
        height: 100%
    }

    .oasispay-packagebox-componesnts .oasispay-title {cursor: default;}

</style>



// WEBPACK FOOTER //
// website/components/packagebox/Packagebox1.vue